module.exports = __webpack_public_path__ + "static/media/consultant-circle.464b510d.svg";